import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4b6e6e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title is-size-4 has-text-centered mb-6" }, "Investment", -1))
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createTextVNode(" Funds raised "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please select the amount of total (public & private) funding raised so far for your innovation/technology"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1))
const _hoisted_7 = {
  class: "control select",
  style: {"width":"100%"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "-1",
  disabled: "",
  selected: ""
}, "Select amount...", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createTextVNode(" Private equity funding "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please select the amount of private funds raised for your innovation/technology"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1))
const _hoisted_12 = { class: "control" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Debt financing ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Crowd sourcing ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Seed capital ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Venture capital ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" IPO ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Other ")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = {
  key: 0,
  class: "field"
}
const _hoisted_26 = { class: "control" }
const _hoisted_27 = {
  key: 1,
  class: "field"
}
const _hoisted_28 = { class: "control" }
const _hoisted_29 = {
  key: 2,
  class: "field"
}
const _hoisted_30 = { class: "control" }
const _hoisted_31 = {
  key: 3,
  class: "field"
}
const _hoisted_32 = { class: "control" }
const _hoisted_33 = {
  key: 4,
  class: "field"
}
const _hoisted_34 = { class: "control" }
const _hoisted_35 = {
  key: 5,
  class: "field"
}
const _hoisted_36 = { class: "control" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = { class: "column" }
const _hoisted_39 = { class: "field" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-7 has-text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" Public grants received "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please indicate your previous or current public projects related to your innovation/technology"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1))
const _hoisted_41 = { class: "control" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Regional grant ")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" National grant ")
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" European grant ")
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" International cooperation grant ")
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Other ")
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_53 = {
  key: 1,
  class: "field"
}
const _hoisted_54 = { class: "control" }
const _hoisted_55 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_56 = {
  key: 2,
  class: "field"
}
const _hoisted_57 = { class: "control" }
const _hoisted_58 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_59 = {
  key: 3,
  class: "field"
}
const _hoisted_60 = { class: "control" }
const _hoisted_61 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_62 = {
  key: 4,
  class: "field"
}
const _hoisted_63 = { class: "control" }
const _hoisted_64 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_65 = {
  key: 5,
  class: "field"
}
const _hoisted_66 = { class: "control" }
const _hoisted_67 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_68 = { class: "field has-text-centered" }
const _hoisted_69 = { class: "checkbox" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" I agree with the ")
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/privacy.html",
  target: "_blank"
}, "privacy statement", -1))
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" and ")
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/terms.html",
  target: "_blank"
}, "terms of service", -1))
const _hoisted_74 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_75 = {
  key: 0,
  class: "help is-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.active)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.investment) = $event)),
                  style: {"width":"100%"}
                }, [
                  _hoisted_8,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investments, (amount, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: amount,
                      key: i
                    }, _toDisplayString(amount), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.data.investment]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.custom.private.dept) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.custom.private.dept]
                  ]),
                  _hoisted_13
                ]),
                _hoisted_14,
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.custom.private.crowd) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.custom.private.crowd]
                  ]),
                  _hoisted_15
                ]),
                _hoisted_16,
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.custom.private.seed) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.custom.private.seed]
                  ]),
                  _hoisted_17
                ]),
                _hoisted_18,
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.custom.private.venture) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.custom.private.venture]
                  ]),
                  _hoisted_19
                ]),
                _hoisted_20,
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.custom.private.ipo) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.custom.private.ipo]
                  ]),
                  _hoisted_21
                ]),
                _hoisted_22,
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.custom.private.other) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.custom.private.other]
                  ]),
                  _hoisted_23
                ]),
                _hoisted_24,
                (_ctx.custom.private.dept)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("p", _hoisted_26, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Debt amount €",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.data.privateDebt) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.privateDebt]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.private.crowd)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("p", _hoisted_28, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Crowd sourcing €",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.data.privateCrowdSourcing) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.privateCrowdSourcing]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.private.seed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("p", _hoisted_30, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Seed capital €",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.data.privateSeed) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.privateSeed]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.private.venture)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("p", _hoisted_32, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Venture capital €",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.data.privateVenture) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.privateVenture]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.private.ipo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("p", _hoisted_34, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "IPO €",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.data.privateIpo) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.privateIpo]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.private.other)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("p", _hoisted_36, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Other description",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.data.privateOther) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.privateOther]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_37
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.custom.public.regional) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.custom.public.regional]
                  ]),
                  _hoisted_42
                ]),
                _hoisted_43,
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.custom.public.national) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.custom.public.national]
                  ]),
                  _hoisted_44
                ]),
                _hoisted_45,
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.custom.public.european) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.custom.public.european]
                  ]),
                  _hoisted_46
                ]),
                _hoisted_47,
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.custom.public.inter) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.custom.public.inter]
                  ]),
                  _hoisted_48
                ]),
                _hoisted_49,
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.custom.public.other) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.custom.public.other]
                  ]),
                  _hoisted_50
                ]),
                _hoisted_51,
                (_ctx.errors.public)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_52, "This field is required"))
                  : _createCommentVNode("", true),
                (_ctx.custom.public.regional)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createElementVNode("p", _hoisted_54, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Amount € of Regional grant",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.data.publicRegional) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.publicRegional]
                        ])
                      ]),
                      (_ctx.errors.publicRegional)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_55, "This field is required"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.public.national)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _createElementVNode("p", _hoisted_57, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Amount € of National grant",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.data.publicNational) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.publicNational]
                        ])
                      ]),
                      (_ctx.errors.publicNational)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_58, "This field is required"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.public.european)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _createElementVNode("p", _hoisted_60, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Amount € of European grant",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.data.publicEuropean) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.publicEuropean]
                        ])
                      ]),
                      (_ctx.errors.publicEuropean)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_61, "This field is required"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.public.inter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _createElementVNode("p", _hoisted_63, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Amount € of International grant",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.data.publicInter) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.publicInter]
                        ])
                      ]),
                      (_ctx.errors.publicInter)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_64, "This field is required"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.public.other)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                      _createElementVNode("p", _hoisted_66, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Describe other public grants",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.data.publicOther) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.publicOther]
                        ])
                      ]),
                      (_ctx.errors.publicOther)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_67, "This field is required"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("label", _hoisted_69, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.agree) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.agree]
            ]),
            _hoisted_70,
            _hoisted_71,
            _hoisted_72,
            _hoisted_73,
            _hoisted_74
          ]),
          (_ctx.errors.agree)
            ? (_openBlock(), _createElementBlock("p", _hoisted_75, "Please read the agreements and confirm you read it"))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}